import { Star, MapPin } from "lucide-react";
import api from "../api/api";
import { useEffect, useState } from "react";
import FeaturedLoader from "../components/Loaders/FeaturedLoader";


export default function FeaturedHotels({ limit = null }) {
    const [hotels, setHotels] = useState([]);
    const [loading, setLoading] = useState(true);



    useEffect(() => {
        api.get("/hotels")
            .then((response) => {
                console.log("RAW API RESPONSE:", response.data); // 👈 ADD THIS

                const data = limit
                    ? response.data.slice(0, limit)
                    : response.data;

                console.log("FINAL HOTELS DATA:", data); // 👈 ALSO THIS

                setHotels(data);
            })
            .catch((error) => {
                console.error("Error fetching hotels:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [limit]);


    if (loading) {
        return (
            <FeaturedLoader
                title="Loading popular destination"
                subtitle="Preparing the best deals for you..."
            />
        );
    }

    return (
        <section className="py-24 bg-gray-50 dark:bg-gray-900">
            <div className="container mx-auto px-6">

                <div className="text-center mb-14">
                    <span className="inline-block bg-blue-100 dark:bg-blue-900/30 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-4">
                        Best Hotel Deals
                    </span>

                    <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-3">
                        Featured Hotel Offers
                    </h2>

                    <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                        Handpicked luxury and budget hotels with exclusive discounts across UAE.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {hotels.map((hotel) => (
                        <div
                            key={hotel.id}
                            className="group bg-white rounded-3xl overflow-hidden shadow-md 
hover:shadow-2xl hover:-translate-y-2 hover:ring-2 hover:ring-blue-200
transition-all duration-500"
                        >
                            {/* Image (Clickable) */}
                            <a href={`/hotels/${hotel.slug ?? hotel.id}`}>
                                <div className="relative h-60 overflow-hidden">

                                    <img
                                        src={`https://uaediscountedhotels.com/uploads/hotels/${hotel.image}`}
                                        alt={hotel.name}
                                        className="w-full h-full object-cover group-hover:scale-110 transition duration-700"
                                    />

                                    {/* Discount Badge */}
                                    {/* Badges */}
                                    <div className="absolute top-4 left-4 flex flex-col gap-2">

                                        {/* Popular / Rating Badge */}
                                        {hotel.rating >= 4.5 ? (
                                            <span className="bg-green-600 text-white text-xs px-3 py-1 rounded-full font-semibold shadow-md">
                                                ⭐ Popular Choice
                                            </span>
                                        ) : (
                                            <span className="bg-blue-600 text-white text-xs px-3 py-1 rounded-full font-semibold shadow-md">
                                                ⭐ {hotel.rating} Rating
                                            </span>
                                        )}

                                    </div>

                                    {/* Gradient */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                                </div>
                            </a>

                            {/* Content */}
                            <div className="p-5">

                                {/* Title (Clickable) */}
                                <a href={`/hotels/${hotel.slug ?? hotel.id}`}>
                                    <h3 className="font-bold text-xl mb-2 text-gray-900 group-hover:text-blue-600 transition">
                                        {hotel.name}
                                    </h3>
                                </a>

                                <div className="flex items-center gap-2 text-gray-500 text-sm mb-3">
                                    <MapPin size={14} />
                                    {hotel.location}
                                </div>

                                <p className="text-gray-600 text-sm line-clamp-2 mb-5">
                                    {hotel.short_description}
                                </p>

                                <div className="flex items-center justify-between">

                                    <div className="text-lg font-bold text-blue-600">
                                        AED {hotel.price_per_night}
                                        <span className="text-xs text-gray-400 font-normal"> / night</span>
                                    </div>

                                    <a
                                        href={`/hotels/${hotel.slug ?? hotel.id}`}
                                        className="px-4 py-2 rounded-lg bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-sm font-medium
shadow-md hover:shadow-xl
transition-all duration-300 ease-in-out
hover:-translate-y-1 hover:scale-105 active:scale-95"
                                    >
                                        View Deal →
                                    </a>

                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center mt-12">
                    <button className="px-8 py-3 rounded-xl border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white transition font-semibold">
                        View All Hotels
                    </button>
                </div>
            </div>
        </section>
    );
}